import { useMutation, useQueryClient } from "@tanstack/react-query";
import { ScheduleTaskDto } from "@myapp/contract";
import { taskApi } from "../service";
import { taskKeys } from "../task.keys";

export function useScheduleTask(id: number) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (dto: ScheduleTaskDto) =>
      taskApi.schedule(id, dto).then((r) => r.data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: taskKeys.detail(id) });
      queryClient.invalidateQueries({ queryKey: taskKeys.lists() });
      queryClient.invalidateQueries({ queryKey: taskKeys.all });
    },
  });
}
